import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, OutlinedInput } from "@mui/material";
import { forwardRef } from "react";
import { MetadataInputProps } from "../metadata-input-index";
import { useTranslation } from "react-i18next";

const MetadataInputSynopsesText = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { t } = useTranslation();
  const { onChange, data, value, predefinedValues } = props;

  return (
    <Autocomplete
      id={data?.tagName ?? undefined}
      // options management
      options={[]}
      freeSolo
      multiple
      getOptionLabel={(option: any) => option.toString()}
      isOptionEqualToValue={(option: any, value: any) => option === value}
      filterOptions={(x, s) => {
        if (!s || !s.inputValue) return x;
        return x.filter((a) => a?.includesAllWords(s.inputValue));
      }}
      // value management
      value={value && value.value ? value.value.map((v) => v.text) : []}
      onChange={(e, v) => onChange(v, data.id)}
      // render input
      popupIcon={<ExpandMoreRoundedIcon />}
      renderInput={(params) => (
        <OutlinedInput
          {...params.InputProps}
          inputProps={params.inputProps}
          required
          sx={{ width: "100%" }}
          placeholder={t("field:placeholder.enterKeyword")}
        />
      )}
      sx={{ width: "100%" }}
    />
  );
});

export default MetadataInputSynopsesText;
